export const XS_BREAKPOINT = 480;
export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;
export const XL_BREAKPOINT = 1200;
